const isServer = typeof window !== 'object';

const query = isServer
  ? {}
  : location.search
      .slice(1)
      .split('&')
      .reduce((record, slice) => {
        const [k, v] = slice.split('=');

        return {
          ...record,
          [k]: v,
        };
      }, {} as Record<string, any>);

export const partnerId: string | undefined = query['partnerid'];
export const brokerId: string | undefined = query['brokerid'];
